/**
 * Purpose: Surface primitive for dashboard content — the single card language
 *          every dashboard module renders into (mirrors the detail-page module
 *          card so the two platforms look like one product).
 * Inputs: title, subtitle, action (node), padded (bool), children, className.
 * Outputs: bordered card; header row rendered only when a title/action exists.
 */
import React from 'react';

const DashboardCard = ({
  title = null,
  subtitle = null,
  action = null,
  padded = true,
  className = '',
  children,
}) => (
  <section
    className={[
      'rounded-2xl border border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-900',
      padded ? 'p-4 sm:p-5' : '',
      className,
    ]
      .filter(Boolean)
      .join(' ')}
  >
    {(title || action) && (
      <div className={`flex items-start justify-between gap-3 ${padded ? 'mb-4' : 'p-4 sm:p-5'}`}>
        <div className="min-w-0">
          {title && (
            <h3 className="truncate text-sm font-bold text-gray-900 dark:text-gray-100">{title}</h3>
          )}
          {subtitle && (
            <p className="mt-0.5 text-xs text-gray-500 dark:text-gray-400">{subtitle}</p>
          )}
        </div>
        {action && <div className="flex-shrink-0">{action}</div>}
      </div>
    )}
    {children}
  </section>
);

export default DashboardCard;
